<template>
  <el-date-picker
    :format="format"
    :value-format="format"
    v-bind="$attrs"
    @input="value => this.$emit('input', value, value)"
  />
</template>

<script>
import { formatDate } from '@utils/common/index'

export default {
  props: {
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    dateNow: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.dateNow) {
      const date = formatDate(Date.now(), this.format)
      this.$emit('input', date, date)
    }
  }
}
</script>
